<template>
    <div class="relative pb-5 border-b border-gray-200 sm:pb-0">
        <div class="md:flex md:items-center md:justify-between">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
                {{ header }}
            </h3>
            <div class="mt-3 flex md:mt-0 md:absolute md:top-3 md:right-0">
                <slot name="action">

                </slot>
                <!--<button type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Share
                </button>-->
            </div>
        </div>
        <div class="mt-4">
            <!-- Dropdown menu on small screens -->
            <!--
            <div class="sm:hidden">
                <label for="current-tab" class="sr-only">Select a tab</label>
                <select id="current-tab" name="current-tab" class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                    <option>Applied</option>

                    <option>Phone Screening</option>

                    <option selected>Interview</option>

                    <option>Offer</option>

                    <option>Hired</option>
                </select>
            </div>-->
            <!-- Tabs at small breakpoint and up -->
            <div class="block">
                <nav class="-mb-px flex space-x-8">
                    <a href="#"
                       v-for="item in options"
                       :key="item.value"
                       @click="selectTab(item.value)"
                       :class="{
                           'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': item.value !== value,
                           'border-indigo-500 text-indigo-600': item.value === value
                       }"
                       class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm">
                        {{ item.text }}
                    </a>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonPrimary from "./ButtonPrimary";
export default {
    name: "Tabs",
    components: {ButtonPrimary},
    props: ['options', 'value', 'header'],

    methods: {
        selectTab(value) {
            this.$emit('input', value);
        },
    },
}
</script>

<style scoped>

</style>